export const PRIMARY = {
  DARKEST: '#1a312d',
  DARK: '#004d40',
  DEFAULT: '#216e54',
  LIGHT: '#c5e4d8',
  LIGHTER: '#deeee8',
  LIGHTEST: '#f0f5f4',
} as const;
